import { type ReactNode } from 'react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/components/ui/Tooltip';

interface PropertyRowProps {
  icon: ReactNode;
  label: string;
  tooltip?: string;
  children: ReactNode;
}

export const PropertyRow = ({
  icon,
  label,
  tooltip,
  children,
}: PropertyRowProps) => {
  const iconAndLabel = (
    <span className="inline-flex items-center gap-2">
      <span className="opacity-60 [&>svg]:w-3.5 [&>svg]:h-3.5 shrink-0">
        {icon}
      </span>
      {label}
    </span>
  );

  return (
    <div className="flex items-center min-h-[40px] py-1.5 gap-0">
      <div className="w-[172px] shrink-0 flex items-center text-[13px] font-medium text-muted-foreground py-2 select-none">
        {tooltip ? (
          <TooltipProvider delayDuration={150}>
            <Tooltip>
              <TooltipTrigger asChild>{iconAndLabel}</TooltipTrigger>
              <TooltipContent side="top" align="start">
                {tooltip}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ) : (
          iconAndLabel
        )}
      </div>
      <div className="flex-1 min-w-0 flex items-center min-h-[40px] relative">
        {children}
      </div>
    </div>
  );
};
